<template>
  <vl-grid>
    <vl-form-column>
      <vl-title tag-name="h2">{{ $t('delivery.create.fileUpload.label') }}</vl-title>
    </vl-form-column>
    <vl-form-column v-show="!loading" v-vl-spacer:bottom.medium>
      <vl-form-message-annotation v-vl-spacer:bottom.small>
        <vl-typography>
          <p>
            {{ $t('delivery.create.fileUpload.help.title') }}
          </p>

          <ul>
            <li>{{ $t('delivery.create.fileUpload.help.zipfile') }}</li>
            <li>{{ $t('delivery.create.fileUpload.help.maxlength') }}</li>
            <li>{{ $t('delivery.create.fileUpload.help.filetypes') }}</li>
          </ul>
        </vl-typography>
      </vl-form-message-annotation>
      <Field v-slot="{ handleChange, value, errors }" name="file">
        <vl-form-message-error v-if="errors">{{ errors[0] }}</vl-form-message-error>
        <vl-upload
          id="data-delivery-upload"
          name="data-delivery-upload"
          :upload-label="$t('delivery.create.fileUpload.label')"
          allowed-file-types=".zip,.7z"
          :max-filesize="750"
          upload-drag-text="Sleep de bijlage naar hier om ze toe te voegen"
          upload-response-error="Er is iets misgelopen tijdens de upload"
          upload-invalid-file-type="Ongeldig bestandstype"
          upload-max-files-exceeded="Het opgeladen bestand is te groot"
          upload-files-hidden-close-label=""
          upload-max-file-size="Het bestand van maximaal "
          url="/api/v1/deliveryrun"
          :mod-error="!!errors.length"
          :max-files="1"
          :options="options"
          :value="value"
          @upload-file-added="handleChange"
          @upload-removed-file="removeFile"
        />
      </Field>
    </vl-form-column>
    <vl-form-column v-if="loading" v-vl-spacer:bottom.medium>
      <div class="pbs-upload-progress">
        <p class="pbs-upload-progress__file">{{ fileName }}</p>
        <p class="pbs-upload-progress__label">
          {{ progress }}%
          <span class="vl-u-visually-hidden">{{ $t('create.delivery.uploaded') }}</span>
        </p>
        <vl-progress
          mod-large
          :value="progress"
          max="100"
          aria-valuenow="23"
          aria-valuemin="0"
          aria-valuemax="100"
          :aria-valuetext="$t('create.delivery.uploaded')"
        />
      </div>
    </vl-form-column>
  </vl-grid>
</template>
<script lang="ts" setup>
import { Field } from 'vee-validate';
import { DropzoneOptions, DropzoneFile } from 'dropzone';
import type Dropzone from 'dropzone';

defineProps<{
  loading?: boolean;
  progress?: number;
  fileName?: string;
}>();

const emit = defineEmits(['fileRemoved']);

const options: DropzoneOptions = {
  init: function (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const dropzone: Dropzone = this;
    // Hack to fix 'reuploading' of a file. Uploading a new file replaces the other one.
    dropzone.on('maxfilesexceeded', function (file: DropzoneFile) {
      dropzone.removeAllFiles();
      dropzone.addFile(file);
    });
  }
};

const removeFile = (): void => {
  emit('fileRemoved');
};
</script>

<style lang="scss">
@import '@govflanders/vl-ui-design-system-style/scss/core/_core.scss';
@import '@govflanders/vl-ui-design-system-style/scss/core/setting/_colors.scss';

.pbs-upload-progress {
  border: 1px $vl-input-border-color solid;
  border-radius: 2px;
  padding: calc(#{$vl-input-padding-sides} * 2);

  &__file {
    text-transform: uppercase;
    display: inline-flex;
    margin-top: -29px;
    margin-left: -5px;
    padding: 0 5px;
    letter-spacing: 1px;
    font-size: 12px;
    color: $vl-text-color;
    background: white;
  }

  &__label {
    text-align: center;
  }
  progress::-moz-progress-bar {
    background: $vl-yellow;
  }
  progress::-webkit-progress-value {
    background: $vl-yellow;
  }
  progress {
    color: $vl-yellow;
  }
}

.vl-upload__files__close {
  display: none;
}
</style>
